<template>
  <v-dialog v-model="isVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="isVisible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Services</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- any button if you want here -->
        </v-toolbar-items>
      </v-toolbar>

      <v-container>
        <v-row justify="center">
          <new-service v-on:Add="AddToList"></new-service>

          <v-spacer></v-spacer>
          <v-autocomplete
            prepend-inner-icon="mdi-magnify"
            :loading="loading"
            :items="items"
            v-model="combomodel"
            :search-input.sync="search"
            class="mx-3"
            flat
            item-text="serviceName"
            label="Services"
            
            clearable
            outlined
          ></v-autocomplete>
        </v-row>
        <service-cards :items="myservices"></service-cards>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import serviceCards from "../main/service/serviceCards.vue";
import axios from "axios";
import newService from "../main/service/newService.vue";

export default {
  data() {
    return {
      isVisible: false,
      lathato: false,
      services: [],
      loading: false,
      search: null,
      items: [],

      select: null,
      combomodel: null
    };
  },
  created() {
    
  },

  methods: {
    AddToList(service) {
      this.services.push(service);
    },
    
    OpenDialog() {
      this.isVisible = true;
      this.services = [];
      this.combomodel = null;
      this.items = [];
      this.GetCompanyServices();
      
    },
    CloseDialog() {
      this.isVisible = false;
    },

    GetCompanyServices() {
      var queryString = `query companyservices($companyID: String!){
                        companyservices(companyID:$companyID){
                            id
                            serviceName
                            duration
                            price
                            companyId
                        }
                    }`;

      axios
        .post("/graphql", {
          query: queryString,
          variables: { companyID: this.$store.getters.user.details.companyId }
        })
        .then(res => {
          if (res.data.data.companyservices != null) {
            this.services = res.data.data.companyservices;
            this.items = this.services;
           this.ConvertServiceDurationsToString();
          }
        })
        .catch(error => console.log(error));
    },
    ConvertServiceDurationsToString() {
      this.items.forEach(element => {
        element.duration = this.$moment.utc(element.duration * 1000).format(
          "HH:mm"
        );
      });
    }
  },
  computed: {
    
    myservices() {
      if (!this.combomodel) {
        return this.services;
      }
      return this.services.filter(s => s.serviceName.includes(this.combomodel));
    }
  },
  components: {
    serviceCards,
    newService
  },
  watch: {
    search(val) {
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      this.myservices.filter(s => s.serviceName.includes(val));
    }
  }
};
</script>

<style>
</style>
